module.exports = __webpack_public_path__ + "img/logo_tainan@2x.d23a1cf1.png";